import React, { useCallback, useEffect, useState } from "react";
import './ProfileAddStaff.css'
import { Button, Card, Col, Dropdown,Select, Radio, Row, Space,DatePicker, message } from 'antd';
import { useLocation, useNavigate } from "react-router-dom";
import { CameraOutlined, CheckCircleFilled, CheckOutlined, ClockCircleFilled, RightOutlined } from '@ant-design/icons';
import { DownOutlined, UserOutlined, CaretDownOutlined } from '@ant-design/icons';
import images1 from '../../assets/images1.jfif'
// import Select from "../../common/Select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { getBase64DataFromBinary } from "../../utils";
import { AddStaff, BASE_URL, DeleteStaff, FetchDepartment, FetchDesignation, FetchLocation, FetchShifts, FetchStaff, UpdateStaff, UploadFile } from "../../utils/constant";
import { useUID, uid } from 'react-uid';
import moment from 'moment';
import { useSelector } from "react-redux";
import SignUpSidebar from "../../common/SignUpSidebar";
import ModalConfirm from "../../common/modalConfirm";
import dayjs from "dayjs";
import Delete from "../../assets/icons/delete.svg";
import Edit from "../../assets/icons/edit.svg";
import Left from '../../assets/icons/left.svg';
function ProfileAddStaff() {
    const navigate = useNavigate();
    const location = useLocation();
    const capitalizeFirstLetter = (str) => {
      return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const [departmentList, setDepartmentList] = useState([]);
    const [departmentFullList, setDepartmentFullList] = useState([]);
    const [subDepartmentList, setSubDepartmentList] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [locationList, setLocationList] = useState([]);
    const [staffDetails, setStaffDetails] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [staffNumber, setStaffNumber] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [permanentAddress, setPermanentAddress] = useState("");
    const [currentAddress, setCurrentAddress] = useState("");
    const [gender, setGender] = useState("");
    const [martialStatus, setMartialStatus] = useState("");
    const [dob, setDob] = useState(null);
    const [doj, setDoj] = useState(null);
    const [designation, setDesignation] = useState("");
    const [department, setDepartment] = useState("");
    const [subDepartmentId, setSubDepartment] = useState("");
    const [shift, setShift] = useState("");
    const [mainSite, setMainSite] = useState([]);
    const [weeklyOff, setWeaklyOff] = useState([]);
    const [isEditModeEnables, setIsEditModeEnables] = useState(null);
    const [logo, setLogo] = useState(null);
    const [staffTitle, setStaffTitle] = useState("Staff 1");
    const signUpDetails = useSelector((state) => state.signUp.signUpDetails);
    const [genderOptions, setGenderOptions] = useState([
        { value: 'male', label: 'male' },
        { value: 'female', label: 'female' },
        { value: 'other', label: 'other' },
        
      ]);
    const [martialStatusOptions, setMartialStatusOptions] = useState([
        { value: 'single', label: 'single' },
        { value: 'married', label: 'married' }        
      ]);
 
    const [weekOffOptions, setWeekOffOptions] = useState([
        { value: 0, label: 'Sunday' },
        { value: 1, label: 'Monday' },
        { value: 2, label: 'Tuesday' },
        { value: 3, label: 'Wednesday' },
        { value: 4, label: 'Thursday' },
        { value: 5, label: 'Friday' },
        { value: 6, label: 'Saturday' },
        
      ]);
      const [modalDeleteStaffVisible, setModalDeleteStaffVisible] = useState(false);
      const [deleteStaffData, setDeleteStaffData] = useState(null);
      
      const deleteStaff = (params) => {
        setModalDeleteStaffVisible(true);
        setDeleteStaffData(params)      
      };
      const handleOk = (params) => {
        console.log('deleteDepartment')
      
        handleDeleteStaff(params)     
        setModalDeleteStaffVisible(false);
      };
      const handleCancel = () => {
        setModalDeleteStaffVisible(false);
      };
    const handlecompany = () => {
      addFinalStaff('dashboard')
      // navigate('/');
    }
    const addcompany = () => {
      addFinalStaff('shift')
      // navigate('/addshift');
    }

    const addFinalStaff = (nextPage) => {
      console.log('nextstaffDetails',staffDetails)
      const token = localStorage.getItem('authToken');
      const dataToSend = {
        staffs: staffDetails
        .filter((item) => !item._id)
        .map((item, index) => ({
          // logo:item.logo,
          logo:item.logo,
          firstName:item.firstName,
          lastName:item.lastName,
          phoneNumber:item.phoneNumber,
          gender:item.gender,
          martialStatus:item.martialStatus,
          dob:item.dob,
          currentAddress:item.currentAddress,
          permanentAddress:item.permanentAddress,
          department:item.department,
          subDepartmentId:item.subDepartmentId,
          designation:item.designation,
          shift:item.shift,
          mainSite:item.mainSite,
          weeklyOff:item.weeklyOff
        })),
      };
      console.log('dataToSend',dataToSend)
      // const parseToken = JSON.parse(token) || {};
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${AddStaff}`, {
        method: "POST",
        headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify(dataToSend),
      });
  
      console.log('CompanyData')
      if (response.ok) {
        const data = await response.json();
  
        console.log('staffDetail',data)
        if(nextPage === "dashboard"){

          navigate("/");
        }else{
          navigate('/addshift');
        }
        
      } else {
        const data = await response.json();
        console.log('staffDetail',data)
        console.log('data?.data?.index',data?.data?.index)
       

          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        
         
     }
     };
     if(dataToSend?.staffs?.length > 0){
  
      fetchData();
      }else{
        if(nextPage === "dashboard"){

          navigate("/");
        }else{
          navigate('/addshift');
        }
      }
    }
    const handleStaffNumber = useCallback((value) => {
        console.log('value',value.target.value)
        setStaffNumber(() => value.target.value);
      }, []);
    const handleFirstName = useCallback((value) => {
        console.log('value',value.target.value)
        setFirstName(() => value.target.value);
      }, []);
    const handleLastName = useCallback((value) => {
        console.log('setLastName',value.target.value)
        setLastName(() => value.target.value);
      }, []);
    const handlePhoneNumber = useCallback((value) => {
        console.log('PhoneNumber',value.target.value)
        setPhoneNumber(() => value.target.value);
      }, []);
    const handlePermanentAddress = useCallback((value) => {
        console.log('PermanentAddress',value.target.value)
        setPermanentAddress(() => value.target.value);
      }, []);
    const handleCurrentAddress = useCallback((value) => {
        console.log('CurrentAddress',value.target.value)
        setCurrentAddress(() => value.target.value);
      }, []);
      const handleGender = useCallback((value) => {
        console.log('value',value)
        setGender(() => value);
      }, []);
      const handleMaritalStatus = useCallback((value) => {
        console.log('value',value)
        setMartialStatus(() => value);
      }, []);
      const handleDobChange = (date, dateString) => {
        console.log('Selected DOB:', dateString);
        console.log(' DOB:', date);
        setDob(date);
      };
      const handleDojChange = (date, dateString) => {
        console.log('Selected DOj:', dateString);
        console.log(' DOj:', date);
        setDoj(date);
      };
      const handleDesignation = useCallback((value) => {
        console.log('value',value)
        setDesignation(() => value);
      }, []);
      const handleWeekOff = useCallback((value) => {
        console.log('value',value)
        setWeaklyOff(() => value);
      }, []);      
      const handleDepartment = (value) => {
        console.log('value',value)
        console.log('departmentList',departmentFullList)
        const selectedDepartment = departmentFullList.find((dept) => dept.departmentId === value);
console.log('selectedDepartment',selectedDepartment)
        // Update subDepartmentList based on the selected department
        if (selectedDepartment && selectedDepartment.subDepartments) {
          const subDepartments = selectedDepartment.subDepartments?.map((subDept) => ({
            value: subDept.subDeptId,
            label: subDept.subDeptName,
          }));
          setSubDepartmentList(subDepartments);
          setSubDepartment('');
        } else {
          // If no subDepartments found, set subDepartmentList as empty array
          setSubDepartmentList([]);
        }
        setDepartment( value);
      };
      const handleSubDepartment = useCallback((value) => {
        console.log('value',value)
        setSubDepartment(() => value);
      }, []);
      const handleShift = useCallback((value) => {
        console.log('value',value)
        setShift(() => value);
      }, []);
      const handleMainSite = useCallback((value) => {
        console.log('value',value)
        setMainSite(() => value);
      }, []);
      
      
      // const progressIdd = useUID();

      const handleUploadLogo = (e) => {
        const file = e.target.files[0];
        console.log('file',file)
        // console.log('progressIdd',progressIdd)
        if (file) {
          // Check if the file type is an image
          if (file.type.startsWith("image/")) {
            const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
            if (file.size <= maxSizeInBytes) {
                // Get the file extension
                const extension = file.name.split('.').pop().toLowerCase();

                // Allowed file extensions
                const allowedExtensions = ['png', 'jpg', 'jpeg'];

                // Check if the file extension is allowed
                if (allowedExtensions.includes(extension)) {
            const fetchData = async () => {

              const formData = new FormData();
              formData.append("files", file);   
              formData.append("folder", 'profilePhotos');   
              // formData.append("progressId", progressIdd);   
              
            
            const response = await fetch(`${BASE_URL}/${UploadFile}`, {
              method: "POST",
              
              body: formData,
            });
            
            if (response.ok) {
              const data = await response.json();
              console.log('data',data)
              setLogo(data?.data[0]);
              // setLogo(file);
              
            } else {
              const data = await response.json();
              toast.error(data.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
              });
              console.log('errdata',data)
                 
             };
             
            
          };
          fetchData();
        } else {
          toast.error('Only PNG, JPG, and JPEG formats are allowed for the logo.', {
              position: toast.POSITION.TOP_RIGHT,
          });
      }
  } else {
      toast.error('File size should be less than or equal to 2 MB.', {
          position: toast.POSITION.TOP_RIGHT,
      });
  }
} else {
  toast.error('Select image only.', {
      position: toast.POSITION.TOP_RIGHT,
  });
}
        }
      };

      const addStaff = () => {
        if (!firstName) {
          toast.error("Please fill in the First Name field.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      } 
      const containsNumbers = /\d/.test(firstName);
      const LastNamecontainsNumbers = /\d/.test(lastName);
    
    if (containsNumbers) {
        toast.error('First Name cannot contain numbers.', {
            position: toast.POSITION.TOP_RIGHT,
        });
        return; // Stop the signup process if the first name contains numbers
    }
      if (!lastName) {
        toast.error('Last Name is required.', {
          position: toast.POSITION.TOP_RIGHT,
        });
        return; // Stop the signup process if the phone number is invalid
      }
      if (LastNamecontainsNumbers) {
        toast.error('Last Name cannot contain numbers.', {
            position: toast.POSITION.TOP_RIGHT,
        });
        return; // Stop the signup process if the first name contains numbers
    }
    if (!phoneNumber) {
          toast.error("Please fill in the Phone Number field.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      } else if (!gender) {
          toast.error("Please select a Gender.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      } else if (!department) {
          toast.error("Please select a Department.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      } else if (!designation) {
          toast.error("Please select a Designation.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      } else if (!shift) {
          toast.error("Please select a Shift.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      }  else if (mainSite.length === 0) {
          toast.error("Please select at least one Main Site.", {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      }
      const phoneNumberRegex = /^[0-9]{10}$/;
      if (!phoneNumberRegex.test(phoneNumber)) {
          // Display an error message for an invalid phone number
          toast.error('Please enter a valid 10-digit phone number.', {
              position: toast.POSITION.TOP_RIGHT,
          });
          return;
      }
        if (isEditModeEnables === null) {
          const dataToSend = {
            staffs: [{
              ...(logo && { logo }),
              ...(firstName && { firstName }),
              ...(lastName && { lastName }),
              ...(phoneNumber && { phoneNumber }),
              ...(gender && { gender }),
              ...(martialStatus && { martialStatus }),
              ...(dob && { dob }),
              ...(doj && { doj }),
              ...(currentAddress && { currentAddress }),
              ...(permanentAddress && { permanentAddress }),
              ...(department && { department }),
              ...(subDepartmentId && { subDepartmentId }),
              ...(designation && { designation }),
              ...(shift && { shift }),
              ...(mainSite && { mainSite }),
              ...(weeklyOff && { weeklyOff }),


              // logo:logo,
              // firstName:firstName,
              // lastName:lastName,
              // phoneNumber:phoneNumber,
              // gender:gender,
              // martialStatus:martialStatus,
              // dob:dob,
              // currentAddress:currentAddress,
              // permanentAddress:permanentAddress,
              // department:department,
              // subDepartmentId:subDepartmentId,
              // designation:designation,
              // shift:shift,
              // mainSite:mainSite,
              // weeklyOff:weeklyOff
            }],
          };
          const token = localStorage.getItem('authToken');

          const fetchData = async () => {
            const response = await fetch(`${BASE_URL}/${AddStaff}`, {
              method: "POST",
              headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${token}`,
                        
                      },
              body: JSON.stringify(dataToSend),
            });
        
            console.log('CompanyData')
            if (response.ok) {
              const data = await response.json();
              getStaffDetails()
              resetStateValues();

            
              
            } else {
              const data = await response.json();
              console.log('staffDetail',data)
              console.log('data?.data?.index',data?.data?.index)
             
      
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              
               
           }
           };
        
            fetchData();
          // setStaffDetails((prev) => [
          //   ...prev,
          //   {
          //     staff: `Staff ${staffDetails.length + 1}`,
          //     logo,
          //     staffNumber,
          //     firstName,
          //     lastName,
          //     phoneNumber,
          //     permanentAddress,
          //     currentAddress,
          //     dob,
          //     gender,
          //     martialStatus,
          //     department,
          //     subDepartmentId,
          //     designation,
          //     shift,
          //     mainSite,
          //     weeklyOff
          //   },
          // ]);
          // setStaffTitle(`Staff ${staffDetails.length + 1}`);
          // resetStateValues();
        } else {
          setStaffDetails((prev) => {
            return prev.map((item, index) => {
              if (index === isEditModeEnables) {
                  if (item._id) {
                    // If locationId is present, it's an update, so you can make your API call here
                    const token = localStorage.getItem('authToken');
                    console.log('item',item)
                    const updateData = {
                      _id: item._id,
                      ...(logo && { logo }),
                      ...(firstName && { firstName }),
                      ...(lastName && { lastName }),
                      ...(phoneNumber && { phoneNumber }),
                      ...(gender && { gender }),
                      ...(martialStatus && { martialStatus }),
                      ...(dob && { dob }),
                      ...(doj && { doj }),
                      ...(currentAddress && { currentAddress }),
                      ...(permanentAddress && { permanentAddress }),
                      ...(department && { department }),
                      ...(subDepartmentId && { subDepartmentId }),
                      ...(designation && { designation }),
                      ...(shift && { shift }),
                      ...(mainSite && { mainSite }),
                      ...(weeklyOff && { weeklyOff }),
                    };
        
                    const fetchData = async () => {
                      const response = await fetch(`${BASE_URL}/${UpdateStaff}`, {
                        method: "POST",
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                        },
                        body: JSON.stringify(updateData),
                      });
        
                      if (response.ok) {
                        const data = await response.json();
                        console.log('staff updated:', data);
                      
                      } else {
                        const data = await response.json();
                       
                        console.log('staff update failed:', data);
                        toast.error(data.errorMessage, {
                          position: toast.POSITION.TOP_RIGHT,
                        });
                      }
                    };
        
                    fetchData();
                  }
    
                    return {
                        _id: item._id,
                        logo,
                        staffNumber,
                        firstName,
                        isActive:item.isActive,
                        lastName,
                        phoneNumber,
                        permanentAddress,
                        currentAddress,
                        dob,
                        doj,
                        gender,
                        martialStatus,
                        department,
                        subDepartmentId,
                        designation,
                        shift,
                        mainSite,
                        weeklyOff
                    };
                  
              } else {
                return item;
              }
            });
          });
          setIsEditModeEnables(null);
          resetStateValues();
        }
        console.log('endlocation',staffDetails)
    };
    const preFillValuesOnEdit = (index) => {
        setIsEditModeEnables(index);

        console.log('staffDetails[index].dob',staffDetails[index].dob)
        console.log('staffDetails[index]',staffDetails[index])
        const {
            logo,
            staffNumber,
            firstName,
            lastName,
            phoneNumber,
            permanentAddress,
            currentAddress,
            dob,
            gender,
            martialStatus,
            department,
            subDepartmentId,
            designation,
            shift,
            mainSite,
            weeklyOff,
            staff
        } = staffDetails[index];
        setLogo(logo);
        setStaffNumber(staffNumber)
        setFirstName(firstName);
        setLastName(lastName);
        setPhoneNumber(phoneNumber);
        setPermanentAddress(permanentAddress);
        setCurrentAddress(currentAddress);
        // setDob(dob)
        setDob(dayjs(staffDetails[index].dob))
        setDoj(dayjs(staffDetails[index].doj))
        setGender(gender);
        setMartialStatus(martialStatus)
        setDepartment(department);
        setSubDepartment(subDepartmentId)
        setDesignation(designation);
        setShift(shift);
        setMainSite(mainSite);
        setWeaklyOff(weeklyOff);
        setStaffTitle(staff);
      };
    const resetStateValues = () => {
        setLogo("");
        setStaffNumber("");
        setFirstName("");
        setLastName("");
        setGender("");
        setMartialStatus("");
        setPhoneNumber("");
        setPermanentAddress("");
        setCurrentAddress("");
        setDob(null)
        setDoj(null)
        setDepartment("");
        setSubDepartment("");
        setDesignation("");
        setShift("");
        setMainSite([]);
        setWeaklyOff([]);
        setStaffTitle("");
      };
  
      const handleAddStaff = () => {
        setStaffDetails((prevDetails) => [
            ...prevDetails,
            {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                // add other fields as needed
            },
        ]);
    };
      const handleDeleteStaff = ({index,staffId}) => {
        const token = localStorage.getItem('authToken');
      console.log('sa',staffId)
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${DeleteStaff}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
              _id:staffId
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            setStaffDetails((prevDetails) =>
            prevDetails.filter((_, i) => i !== index)
          );
          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
         fetchData();
       
      };
    const [value, setValue] = useState(1);
    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };
    const handleMenuClick = (e) => {
        message.info('Click on menu item.');
        console.log('click', e);
    };
    const items = [
        {
            label: '1st menu item',
            key: '1',
            icon: <UserOutlined />,
        },
        {
            label: '2nd menu item',
            key: '2',
            icon: <UserOutlined />,
        },
        {
            label: '3rd menu item',
            key: '3',
            icon: <UserOutlined />,
            danger: true,
        },
        {
            label: '4rd menu item',
            key: '4',
            icon: <UserOutlined />,
            danger: true,
            disabled: true,
        },
    ];
    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    useEffect(() => {

      getStaffDetails();
      getAllDropdownList();
    }, []);
    const getStaffDetails = async () =>{
      const token = localStorage.getItem('authToken');
    try{
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
          method: "POST",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify({}),
        });
        
        if (response.ok) {
          const data = await response.json();
          const activeStaff = data.data.filter(item => item.isActive);
          console.log('activeStaff',activeStaff)
          const transformedStaff = activeStaff.map(staffItem => {
            // Assuming mainSite is an array property in each staffItem
            const locationOption = staffItem?.mainSite?.map(item => ( item.locationId
           ));
           
  const subDepartmentOption =staffItem?.subDepartmentId?.subDeptId
  const departmentOption =staffItem?.department?.departmentId
  const subDepartments = staffItem?.department?.subDepartments?.map((subDept) => ({
    value: subDept.subDeptId,
    label: subDept.subDeptName,
  }));
  setSubDepartmentList(subDepartments);

  const designationOption = staffItem?.designation?.designationId

  const shiftOption = staffItem?.shift?.shiftId
          
            // Update the mainSite property with the transformed data
            return {
              ...staffItem,
              mainSite: locationOption,
              department: departmentOption,
              subDepartmentId: subDepartmentOption,
              designation: designationOption,
              shift: shiftOption,
            };
          });
          
          console.log('transformedStaff', transformedStaff);
          setStaffDetails(transformedStaff);
          // setStaffDetails(activeStaff)
          setStaffTitle(`Staff ${transformedStaff.length + 1}`);
          // setLocations(tableshowData);
        
        } else {
          const data = await response.json();
          console.log('departmenterr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      await fetchData();
    } catch (error) {
      console.error('Error updating designation:', error);
  }
    }
    function formatTimeWithAMPM(milliseconds) {
      const hours = Math.floor(milliseconds / 3600000);
      const minutes = Math.round((milliseconds % 3600000) / 60000);
    
      const formattedHours = hours % 12 || 12;
      const ampm = hours >= 12 ? 'PM' : 'AM';
    
      return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
    }
    const getAllDropdownList = async () =>{
      const token = localStorage.getItem('authToken');
    
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
          method: "POST",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify({isDeleted:false}),
        });
        
        if (response.ok) {
          const data = await response.json();
          const activeLocations = data.data.filter(item => item.isActive);
  
          console.log('departmentt',activeLocations)
           setDepartmentFullList(activeLocations)
          const departmentOption = activeLocations?.map((item) => ({
            value: item.departmentId,
            label: item.departmentName,
          }));
          console.log('departmentOption',departmentOption)
          setDepartmentList(departmentOption)
          
    
          // setLocations(tableshowData);
        
        } else {
          const data = await response.json();
          console.log('departmenterr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      const fetchDesignationData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
          method: "POST",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify({isDeleted:false}),
        });
        
        if (response.ok) {
          const data = await response.json();
          const activeLocations = data.data.filter(item => item.isActive);
  
          console.log('designation',activeLocations)
          const designationOption = activeLocations?.map((item) => ({
            value: item.designationId,
            label: item.designationName,
          }));
          console.log('designationOption',designationOption)
          setDesignationList(designationOption)
    
          // setLocations(tableshowData);
        
        } else {
          const data = await response.json();
          console.log('departmenterr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      const fetchShiftData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
          method: "POST",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify({}),
        });
        
        if (response.ok) {
          const data = await response.json();
          const activeLocations = data.data.filter(item => item.isActive);
  
          console.log('shift',activeLocations)
          const shiftOption = activeLocations?.map((item) => ({
            value: item.shiftId,
            label: `${item.shiftFullName} (${formatTimeWithAMPM(item.shiftStartTime)} - ${formatTimeWithAMPM(item.shiftEndTime)})`
          }));
          console.log('shiftOption',shiftOption)
          setShiftList(shiftOption)
    
          // setLocations(tableshowData);
        
        } else {
          const data = await response.json();
          console.log('shifterr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      const fetchLocationData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
          method: "POST",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify({isDeleted:false}),
        });
        
        if (response.ok) {
          const data = await response.json();
          const activeLocations = data.data.filter(item => item.isActive);
  
          console.log('shift',activeLocations)
          const locationOption = activeLocations?.map((item) => ({
            value: item.locationId,
            label: item.locationName1,
          }));
          console.log('locationOption',locationOption)
          setLocationList(locationOption)
    
          // setLocations(tableshowData);
        
        } else {
          const data = await response.json();
          console.log('shifterr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      await fetchData();
      await fetchDesignationData();
      await fetchShiftData();
      await fetchLocationData();
    }
    const disabledDate = current => {
      // Disable future dates
      return current && current > moment().endOf('day');
    };
    return (
        <>
           
            <ToastContainer position="top-right" autoClose={2000} />
            <div className="h-full">
        <Row className="2xl:h-full xl:h-auto">
            <SignUpSidebar isStaff={ true } location={location.pathname} />
             
                <Col lg={14} className="bg-[#F5FBFE] h-full text-base overflow-auto">
                    <div className=" flex flex-col pt-10">
                        <div className="font-bold text-[28px] text-center mt-3 mb-4">Add Staff</div>
                          <div className='flex mt-3'>
                            <div className='flex flex-nowrap overflow-x-auto overflow-y-visible ml-7 slimScroll' style={{ overflowX: 'auto' }}>
                              {staffDetails.map((staff, index) => (
                              <div key={index} className='bg-[#DCE6EE] rounded-2xl justify-center flex flex-col mr-4 px-3 py-2 gap-2 !pt-[14px] min-w-[225px]' >
                                <div className='text-[#00305F] font-bold flex items-end'>
                                  <div className="leading-none">{`Staff ${index + 1}`}</div>
                                  <img
                                    src={Edit}
                                    onClick={() => preFillValuesOnEdit(index)}
                                    className="ml-4 cursor-pointer"
                                    alt="edit location"
                                  />
                                  <img
                                    src={Delete}
                                    onClick={() => deleteStaff({index, staffId:staff._id})}
                                    className="ml-2 cursor-pointer"
                                    alt="delete location"
                                  />
                                </div>
                                <div className='flex items-end'>
                                  {staff?.logo && <img src={staff?.logo}
                                    className="w-4 h-4 rounded-full"
                                    alt={`Staff ${index + 1}`}/>
                                  }
                                  <p className='text-sm leading-none ml-1'>{capitalizeFirstLetter(staff?.firstName) } {' '} {capitalizeFirstLetter(staff?.lastName)}</p>
                                </div>
                                <p className='text-sm'>{staff?.phoneNumber }</p>
                              </div>
                              ))}
                            </div>
                          </div>
                        <div className="wrapper">
                          <div className="mx-auto w-3/4 ">
                            <div className='mt-5 text-[#00305F] text-sm font-sbold'>{`Staff ${staffDetails.length + 1}`}</div>
                            <div className="bg-[#E4ECF3] !p-4 rounded-[30px]">
                              <div className="text-[13px] text-[#4B8AEB] font-sbold">PERSONAL DETAILS</div>
                              <div className="bg-[#D0DCE6] rounded-[20px] !p-4">
                                <div className='px-0'>
                                  <Row className="items-start">
                                      <Col lg={3}>
                                          {/* <div className="pro-add-add-image-back">
                                              <img className='pro-add-add-image-tab' style={{ width: "50px", height: "50px" }} src={images1} alt="" />
                                          </div> */}
                                          <div className="text-center">
                                            <label className="w-[94px] h-[94px] bg-[#E4ECF3] flex items-center justify-center mx-auto rounded-2xl cursor-pointer relative">
                                              {!logo && (
                                                <span className="w-6 h-6 bg-white rounded-full inline-flex items-center justify-center absolute bottom-[-10px] left-0 right-0 mx-auto">
                                                  <CameraOutlined className="text-[#4B8AEB]" />
                                                </span>
                                              )}
                                              <input
                                                type="file"
                                                className="hidden"
                                                accept="image/*"
                                                onChange={handleUploadLogo}
                                              />
                                              {logo && (
                                                <img
                                                  // src={getBase64DataFromBinary(logo)}
                                                  src={logo}
                                                  alt="company_logo"
                                                  className="overflow-hidden rounded-2xl w-full h-full object-cover"
                                                />
                                              )}
                                            </label>
                                            <small className="block text-xs text-[#CE0000] leading-[14px] !mt-[12px]">This photo will be used to mark attendance of the employee</small>
                                          </div>
                                          {/* <p className='pro-add-red-contain'>This photo will used to mark attendance of the employee</p> */}
                                      </Col>
                                      <Col lg={21}>
                                      <div className='block justify-between !pl-4'>
                                        <Row className="staffLab" gutter={[16, 8]}>
                                          <Col span={8}>
                                          <label className='mb-0 mt-1'>Staff Number</label>
                                          <input
                                    placeholder="Staff Number"
                                    className="w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none"
                                    type="text"
                                    value={staffNumber}
                                    onChange={handleStaffNumber}
                                    disabled={true}
                                />
                                          </Col>
                                          <Col span={8}>
                                          <label className='mb-0 mt-1'>First Name<span className='text-red-500'>*</span></label>
                                          <input
                                    placeholder="First Name"
                                    className="w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none"
                                    type="text"
                                    value={firstName}
                                    onChange={handleFirstName}
                                />
                                          </Col>
                                          <Col span={8}>
                                          <label className='mb-0 mt-1'>Last Name<span className='text-red-500'>*</span></label>
                                          <input
                                    placeholder="Last Name"
                                    className="w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none"
                                    type="text"
                                    value={lastName}
                                    onChange={handleLastName}
                                />
                                          </Col>
                                          <Col span={8}>
                                          <label className='mb-0 mt-1'>Gender<span className='text-red-500'>*</span></label>
                                          <select
                                      required
                                      onChange={(e) => handleGender(e.target.value)}
                                      value={gender}
                                      className={gender === '' ? 'w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder' : 'w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none'}
                                    >
                                      <option value="" disabled selected>
                                        Gender
                                      </option>
                                      {genderOptions.map((item, index) => {
                                        return (
                                          <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => handleGender(item.value)}>
                                            {item.label}
                                          </option>
                                        );
                                      })}
                                    </select>
                                          </Col>
                                          <Col span={8}>
                                          <label className='mb-0 mt-1'>Phone Number<span className='text-red-500'>*</span></label>
                                          <input
                                    placeholder="Phone number"
                                    className="w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none"
                                    type="tel"
                                    value={phoneNumber}
                                    onChange={handlePhoneNumber}
                                    maxLength={10}
                                />
                                          </Col>
                                          <Col span={8}>
                                            {/* <Select
                                            className="mb-2"
                                              placeholder="Marital status"
                                              style={{ width: '100%' }}
                                              onChange={(value) => handleMaritalStatus(value)}
                                              value={martialStatus}
                                            >
                                              {martialStatusOptions.map((item, index) => (
                                                <Select.Option key={index} value={item.value}>
                                                  {item.label}
                                                </Select.Option>
                                              ))}
                                            </Select> */}
                                          <label className='mb-0'>Martial Status</label>
                                            <select
                                              required
                                              onChange={(e) => handleMaritalStatus(e.target.value)}
                                              value={martialStatus}
                                              className={martialStatus === '' ? 'text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder' : 'text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder'}
                                            >
                                              <option value="" disabled selected>Marital status</option>
                                              {martialStatusOptions.map((item, index) => {
                                                return (
                                                  <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => handleMaritalStatus(item.value)}>
                                                    {item.label}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                          </Col>
                                          <Col span={8}>
                                            <label className='mb-0'>Permanent Address</label>
                                            <input 
                                            placeholder="Permanent Address"
                                            className="text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder text-sm"
                                            type="text"
                                            value={permanentAddress}
                                            onChange={handlePermanentAddress}
                                            />
                                          </Col>
                                          <Col span={8}>
                                            <label className='mb-0'>Current Address</label>
                                            <input
                                            placeholder="Current Address"
                                            className="text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder text-sm"
                                            type="text"
                                            value={currentAddress}
                                            onChange={handleCurrentAddress}
                                            />
                                          </Col>
                                          <Col span={8}>
                                          <label className='mb-0'>DOB</label>
                                            <DatePicker
                                              placeholder="Date of Birth"
                                              className="text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder border-none text-sm"
                                              format="YYYY-MM-DD"
                                              onChange={handleDobChange}
                                              // defaultValue={dob ? moment(dob).locale('en') : null}
                                              value={dob ? dob : null}
                                              disabledDate={disabledDate}
                                            />
                                          </Col>
                                          <Col span={8}>
                                          <label className='mb-0'>DOJ</label>
                                            <DatePicker
                                              placeholder="Date of Joining"
                                              className="w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder border-none text-sm"
                                              format="YYYY-MM-DD"
                                              onChange={handleDojChange}
                                              // defaultValue={dob ? moment(dob).locale('en') : null}
                                              value={doj ? doj : null}
                                              disabledDate={disabledDate}
                                            />
                                          </Col>
                                        </Row>
                                      </div>
                                      
                                          {/* <p className='pro-add-can'>Can be manually overridden</p> */}
                                      </Col>
                                  </Row>
                                </div>
                              </div>
                              <div className="text-[13px] text-[#4B8AEB] font-sbold mt-4">WORK DETAILS</div>
                              <div className='bg-[#D0DCE6] rounded-[20px] !p-4'>
                                <Row className="staffLab" gutter={[16,8]}>
                                  <Col span={8}>
                                  <label className='mb-0 mt-1'>Designation<span className='text-red-500'>*</span></label>
                                  <select
                                  className={`text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder text-sm ${designation === '' ? 'placeholder' : ''}`}
                                  required
                                  onChange={(e) => handleDesignation(e.target.value)}
                                  value={designation}

                                >
                                  <option value="" disabled selected>
                                    Designation
                                  </option>
                                  {designationList.map((item, index) => {
                                    return (
                                      <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => handleDesignation(item.value)}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                                  </Col>
                                  <Col span={8}>
                                  <label className='mb-0 mt-1'>Department<span className='text-red-500'>*</span></label>
                                  <select
                                  required
                                  onChange={(e) => handleDepartment(e.target.value)}
                                  value={department}
                                  className={`text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder text-sm ${department === '' ? 'placeholder' : ''}`}

                                  >
                                  <option value="" disabled selected>
                                    Department
                                  </option>
                                  {departmentList.map((item, index) => {
                                    return (
                                      <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => handleDepartment(item.value)}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                                  </Col>
                                  <Col span={8}>
                                  <label className='mb-0 mt-1'>Sub Department</label>
                                  <select
                                  required
                                  onChange={(e) => handleSubDepartment(e.target.value)}
                                  value={subDepartmentId}
                                  className={`text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder text-sm ${subDepartmentId === '' ? 'placeholder' : ''}`}
                                  >
                                  <option value="" disabled selected>
                                    Sub Department
                                  </option>
                                  {subDepartmentList.map((item, index) => {
                                    return (
                                      <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => handleSubDepartment(item.value)}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                                  </Col>
                                  <Col >
                                  <label className='mb-0 mt-1'>Weekly Off</label>

                                  <Select
                                    mode="multiple"
                                    allowClear
                                    className="w-100 [&_.ant-select-selector]:h-[55px] [&_.ant-select-selector]:!bg-[#BACAD8] [&_.ant-select-selector]:!border-none [&_.ant-select-selector]:!px-5 [&_.ant-select-selector]:rounded-3xl [&_.ant-select-selection-item]:!bg-[rgb(208 220 230)]"
                                    maxTagCount={2}
                                    placeholder="Weekly Off"
                                    style={{width :'auto'}}
                                    // defaultValue={weeklyOff.length > 0 ? [weeklyOff] : [] }
                                    value={weeklyOff}
                                    onChange={handleWeekOff}
                                    options={weekOffOptions}
                                  />
                                </Col>
                                </Row>
                              </div>
                              <div className="text-[13px] text-[#4B8AEB] font-sbold mt-4 uppercase">Optional Deatails</div>
                              <div className='bg-[#D0DCE6] rounded-[20px] !p-4'>
                                <Row className="staffLab" gutter={16}>
                                  <Col span={8}>
                                    <label className='mb-0 mt-1'>Shift<span className='text-red-500'>*</span></label>
                                    <select
                                      required
                                      onChange={(e) => handleShift(e.target.value)}
                                      value={shift}
                                      className={`text-black w-100 h-[55px] rounded-[28px] bg-[#BACAD8] !px-5 !outline-none placeholder text-sm ${shift === '' ? 'placeholder' : ''}`}
                                    >
                                    <option value="" disabled selected>Shift</option>
                                      {shiftList.map((item, index) => {
                                      return (
                                        <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => handleShift(item.value)}>
                                          {item.label}
                                        </option>
                                      );
                                      })}
                                    </select>
                                  </Col>
                                  <Col >
                                  <label className='mb-0 mt-1'>Main Site<span className='text-red-500'>*</span></label>
                                  <Select
                                  mode="multiple"
                                  className="w-100 [&_.ant-select-selector]:h-[55px] [&_.ant-select-selector]:!bg-[#BACAD8] [&_.ant-select-selector]:!border-none [&_.ant-select-selector]:!px-5 [&_.ant-select-selector]:rounded-3xl [&_.ant-select-selection-item]:!bg-[rgb(208 220 230)]"
                                  allowClear
                                  placeholder="Main Site"
                                  maxTagCount={2}
                                  onChange={handleMainSite}
                                  value={mainSite}
                                  options={locationList}
                                  />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='desig-center'>
                          <Button className='h-10 border !border-[#00305F] text-[#00305F] rounded-full hover:bg-[#00305F] hover:!text-white px-4 !outline-none' onClick={addStaff}>
                            <span className="font-sbold text-sm">Add Staff</span></Button>
                          {/* <p className='desig-add-plush'>+Add More Company</p> */}
                        </div>
                        <div className='flex mb-5 pr-5 gap-3 justify-end items-center'>
                          <div className="mt-1">
                            <img src={Left} onClick={addcompany} className='w-12 cursor-pointer'/>
                          </div>
                          <div onClick={handlecompany} className='text-xl bg-[#4B8AEB] rounded-full text-white w-32 h-12 inline-flex items-center justify-center cursor-pointer'>
                            <CheckOutlined className='font-bold mr-2 text-lg' />
                            <span >Finish</span>
                          </div>
                        </div>
                    </div>
                </Col>
            </Row>


            <ModalConfirm
        visible={modalDeleteStaffVisible}
        onOk={() => handleOk(deleteStaffData)}
        onCancel={handleCancel}
        title="Delete"
        content="Are you sure you want to delete?"
      />
        </div>
        </>
    )
}

export default ProfileAddStaff